/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Saved Map View Icon component.
 */
export const SavedMapViewsIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M8.05494 5.85622C8.16483 5.88879 8.28258 5.88262 8.38846 5.83874L14.9448 3.12147C15.0506 3.07763 15.1682 3.07143 15.278 3.10389L21.6418 4.98554C21.8542 5.04836 22 5.24348 22 5.46502V20.5164C22 20.8505 21.6786 21.0906 21.3582 20.9959L15.2783 19.1981C15.1683 19.1656 15.0505 19.1719 14.9447 19.2159L8.40475 21.9327C8.29888 21.9767 8.1811 21.983 8.07116 21.9505L1.70765 20.0689C1.4952 20.0061 1.34942 19.811 1.34942 19.5894V4.5385C1.34942 4.20427 1.67105 3.96414 1.99151 4.05911L8.05494 5.85622Z' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M15.0513 3V19.0901' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M8.26953 5.70996V21.8001' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <rect x='12' y='2' width='9' height='9' rx='4.5' fill={iconColor} />
      <path d='M13.875 6.5H19.1812' stroke={dlsColor('white')} strokeMiterlimit='10' strokeLinecap='round' />
      <path d='M16.5 9.18125V3.875' stroke={dlsColor('white')} strokeMiterlimit='10' strokeLinecap='round' />
    </svg>
  );
};

export default SavedMapViewsIcon;
